import { createContext, useState } from 'react'

export const ReplayTerminalContext = createContext()

export const ReplayTerminalProvider = ({ children }) => {
  const [terminalOutput, setTerminalOutput] = useState([])

  const [isRunning, setIsRunning] = useState(false)

  const [testResults, setTestResults] = useState([])

  // In case UI calls it, it does nothing
  const runTests = () => {}

  return (
    <ReplayTerminalContext.Provider value={{ 
      terminalOutput, 
      setTerminalOutput, 
      
      isRunning,      
      setIsRunning,      
      
      testResults, 
      setTestResults,    
      
      runTests 
    }}>
      {children}
    </ReplayTerminalContext.Provider>
  )
}